module.exports = "<h4>Bienvenido(a) a la administración de {{ empresaId === 1 ? 'Kabik' : 'Letech' }} v{{ version }}</h4>\r\n"